import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const FACEBOOK_URL = 'https://www.facebook.com/theguyinsaa';
const INSTAGRAM_URL = 'https://www.instagram.com/theguyinsa';
const FACEBOOK_PAGE = 'theguyinsaa';

export default function SocialFeed() {
  const { language } = useLanguage();
  const isPt = language === 'pt';

  return (
    <section className="section-padding bg-slate-50" data-testid="social-feed-section">
      <div className="container-custom">
        <div className="text-center mb-10">
          <span className="text-xs font-bold uppercase tracking-widest text-[#F59E0B] mb-2 block">
            {isPt ? 'Siga-nos' : 'Follow Us'}
          </span>
          <h2 className="text-2xl font-bold text-slate-900">
            {isPt ? 'Acompanhe o nosso trabalho' : 'See What We Do'}
          </h2>
          <p className="text-slate-500 mt-2">
            {isPt ? 'Casos reais, entregas reais, resultados reais.' : 'Real cases, real deliveries, real results.'}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Facebook Embed */}
          <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm">
            <div className="p-4 border-b border-slate-100 flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-[#1877F2] flex items-center justify-center">
                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </div>
              <div>
                <p className="font-bold text-slate-800 text-sm">The Guy in SA</p>
                <p className="text-xs text-slate-400">Facebook</p>
              </div>
              <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer"
                className="ml-auto text-xs font-medium text-[#1877F2] hover:underline" data-testid="social-facebook-link">
                {isPt ? 'Seguir' : 'Follow'}
              </a>
            </div>
            <div className="relative" style={{ minHeight: '400px' }}>
              <iframe
                src={`https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(FACEBOOK_URL)}&tabs=timeline&width=500&height=400&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=false`}
                width="100%"
                height="400"
                style={{ border: 'none', overflow: 'hidden' }}
                scrolling="no"
                frameBorder="0"
                allowFullScreen={true}
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                title="Facebook Feed"
              />
            </div>
          </div>

          {/* Instagram Embed */}
          <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm">
            <div className="p-4 border-b border-slate-100 flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#833AB4] via-[#FD1D1D] to-[#F77737] flex items-center justify-center">
                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              </div>
              <div>
                <p className="font-bold text-slate-800 text-sm">@theguyinsa</p>
                <p className="text-xs text-slate-400">Instagram</p>
              </div>
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer"
                className="ml-auto text-xs font-medium text-[#E1306C] hover:underline" data-testid="social-instagram-link">
                {isPt ? 'Seguir' : 'Follow'}
              </a>
            </div>
            <div className="p-4 space-y-4" style={{ minHeight: '400px' }}>
              {/* Instagram doesn't allow easy embedding without oEmbed/API, show CTA */}
              <div className="flex flex-col items-center justify-center h-full py-12 text-center">
                <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#833AB4] via-[#FD1D1D] to-[#F77737] flex items-center justify-center mb-4">
                  <svg className="w-10 h-10 text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
                </div>
                <h3 className="text-lg font-bold text-slate-800 mb-2">@theguyinsa</h3>
                <p className="text-slate-500 text-sm mb-4 max-w-xs">
                  {isPt ? 'Veja os nossos casos de procurement, entregas e bastidores.' : 'See our procurement cases, deliveries and behind the scenes.'}
                </p>
                <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-6 py-2.5 bg-gradient-to-r from-[#833AB4] via-[#FD1D1D] to-[#F77737] text-white font-bold rounded-full text-sm hover:opacity-90 transition-opacity">
                  {isPt ? 'Ver no Instagram' : 'View on Instagram'}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
